import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import contactPortalService from '../services/contactPortal';
import './ContactPortal.scss';

const initialForm = {
  first_name: '',
  last_name: '',
  cuil: '',
  email: '',
  phone: '',
  phone2: '',
  address: ''
};

const ContactRegister = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [generalError, setGeneralError] = useState('');
  const [success, setSuccess] = useState('');

  const onChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (fieldErrors[field]) {
      setFieldErrors((prev) => ({ ...prev, [field]: '' }));
    }
    if (generalError) setGeneralError('');
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setFieldErrors({});
    setGeneralError('');
    setSuccess('');

    try {
      await contactPortalService.register({
        ...form,
        cuil: form.cuil.replace(/\D/g, '')
      });
      setForm(initialForm);
      setSuccess('Registro recibido. Revisa tu email para activar la cuenta.');
    } catch (err) {
      const detail = err.response?.data;
      if (detail && typeof detail === 'object') {
        const parsedErrors = {};

        Object.entries(detail).forEach(([key, value]) => {
          const message = Array.isArray(value) ? value[0] : String(value);
          parsedErrors[key] = message;
        });

        setFieldErrors(parsedErrors);

        if (parsedErrors.non_field_errors) {
          setGeneralError(parsedErrors.non_field_errors);
        }
      } else {
        setGeneralError('No se pudo completar el registro.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-portal-auth-page">
      <div className="auth-card auth-card-register">
        <h1>Registro de Contacto</h1>
        {!success && <p>Completa tus datos para solicitar acceso al portal.</p>}

        {!success ? (
          <>
            <form onSubmit={onSubmit}>
              <label htmlFor="first_name">Nombre</label>
              {fieldErrors.first_name && <div className="field-error">{fieldErrors.first_name}</div>}
              <input
                id="first_name"
                value={form.first_name}
                onChange={(e) => onChange('first_name', e.target.value)}
              />

              <label htmlFor="last_name">Apellido</label>
              {fieldErrors.last_name && <div className="field-error">{fieldErrors.last_name}</div>}
              <input
                id="last_name"
                value={form.last_name}
                onChange={(e) => onChange('last_name', e.target.value)}
              />

              <label htmlFor="cuil">CUIL</label>
              {fieldErrors.cuil && <div className="field-error">{fieldErrors.cuil}</div>}
              <input
                id="cuil"
                value={form.cuil}
                onChange={(e) => onChange('cuil', e.target.value)}
                required
              />

              <label htmlFor="email">Email</label>
              {fieldErrors.email && <div className="field-error">{fieldErrors.email}</div>}
              <input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => onChange('email', e.target.value)}
                required
              />

              <label htmlFor="phone">Telefono</label>
              {fieldErrors.phone && <div className="field-error">{fieldErrors.phone}</div>}
              <input
                id="phone"
                value={form.phone}
                onChange={(e) => onChange('phone', e.target.value)}
              />

              <label htmlFor="phone2">Telefono alternativo</label>
              {fieldErrors.phone2 && <div className="field-error">{fieldErrors.phone2}</div>}
              <input
                id="phone2"
                value={form.phone2}
                onChange={(e) => onChange('phone2', e.target.value)}
              />

              <label htmlFor="address">Direccion</label>
              {fieldErrors.address && <div className="field-error">{fieldErrors.address}</div>}
              <input
                id="address"
                value={form.address}
                onChange={(e) => onChange('address', e.target.value)}
              />

              {generalError && <div className="error-message">{generalError}</div>}

              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? 'Enviando...' : 'Registrarme'}
              </button>
            </form>

            <p className="auth-footer">
              Ya tenes cuenta? <Link to="/contactos/login">Inicia sesion</Link>
            </p>
          </>
        ) : (
          <>
            <div className="success-message">{success}</div>
            <p className="auth-footer">
              <Link to="/contactos/login">Ir a Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactRegister;
